import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { toast } from "sonner";
import { Copy, Spinner, ArrowLeft, CheckCircle, Flask } from "@phosphor-icons/react";
import { brl } from "@/lib/api";

const steps = ["Abra o app do seu banco", "Escolha pagar com Pix QR Code ou Copia e Cola", "Confirme — a liberação é automática"];

export const PixPanel = ({ pix, onCheckNow, onBack, onSimulate, loading }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pix.qr_code || "");
      toast.success("Código Pix copiado!");
    } catch {
      toast.error("Não foi possível copiar. Selecione o código manualmente.");
    }
  };

  return (
    <div data-testid="pix-panel">
      <div className="text-center">
        <div className="text-xs uppercase tracking-[0.18em] text-emerald-400 font-semibold">Pague com Pix</div>
        <div className="font-display font-black text-3xl sm:text-4xl mt-1 tabular-nums" data-testid="pix-amount">{brl(pix.amount)}</div>
      </div>

      <div className="mt-5 mx-auto w-fit bg-white p-3 rounded-2xl shadow-[0_0_50px_rgba(34,197,94,0.25)]" data-testid="pix-qr-code-image">
        {pix.qr_code_base64 ? (
          <img src={`data:image/png;base64,${pix.qr_code_base64}`} alt="QR Code Pix" className="w-52 h-52 sm:w-56 sm:h-56" />
        ) : (
          <QRCodeSVG value={pix.qr_code || "PIX"} size={208} bgColor="#ffffff" fgColor="#0B0E14" />
        )}
      </div>

      <div className="mt-5">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">Pix Copia e Cola</div>
        <div className="flex gap-2">
          <input
            readOnly
            value={pix.qr_code || ""}
            onFocus={(e) => e.target.select()}
            data-testid="pix-copia-cola-text"
            className="flex-1 min-w-0 bg-black/30 border border-white/10 rounded-xl px-3 py-3 text-xs font-mono text-slate-300 outline-none"
          />
          <button type="button" onClick={copy} className="shrink-0 inline-flex items-center gap-1.5 px-4 rounded-xl bg-emerald-500 text-black font-bold text-sm hover:bg-emerald-400 transition-colors" data-testid="pix-copy-code-btn">
            <Copy size={16} weight="bold" /> Copiar
          </button>
        </div>
      </div>

      <ol className="mt-5 space-y-2">
        {steps.map((s, i) => (
          <li key={s} className="flex items-center gap-3 text-sm text-slate-300">
            <span className="w-6 h-6 shrink-0 rounded-full bg-white/5 border border-white/10 text-xs font-bold flex items-center justify-center">{i + 1}</span>
            {s}
          </li>
        ))}
      </ol>

      <div className="mt-5 flex items-center gap-3 rounded-2xl border border-emerald-500/30 bg-emerald-500/[0.06] p-4" data-testid="pix-waiting">
        <Spinner size={22} className="animate-spin text-emerald-400 shrink-0" />
        <div className="text-sm">
          <div className="font-semibold">Aguardando pagamento…</div>
          <div className="text-xs text-slate-400 mt-0.5">Verificamos automaticamente a cada 3 segundos.</div>
        </div>
      </div>

      <button type="button" onClick={onCheckNow} disabled={loading} className="vb-cta vb-cta-green mt-4" data-testid="pix-check-now-btn">
        {loading ? <Spinner size={20} className="animate-spin" /> : <CheckCircle size={20} weight="fill" />}
        Já paguei · verificar agora
      </button>

      {pix.mock && onSimulate && (
        <button type="button" onClick={onSimulate} disabled={loading} className="mt-3 w-full inline-flex items-center justify-center gap-2 py-3 rounded-xl border border-dashed border-[#FFB30F]/50 text-[#FFB30F] text-sm font-semibold hover:bg-[#FFB30F]/5 transition-colors" data-testid="pix-simulate-payment-btn">
          <Flask size={16} /> Simular pagamento (sandbox)
        </button>
      )}

      <button type="button" onClick={onBack} className="mt-4 mx-auto flex items-center gap-1.5 text-xs text-slate-400 hover:text-white transition-colors" data-testid="pix-back-btn">
        <ArrowLeft size={13} /> Trocar forma de pagamento
      </button>
    </div>
  );
};
